import { render, staticRenderFns } from "./PwSearchResultSend.vue?vue&type=template&id=5a7e24e9&scoped=true&"
import script from "./PwSearchResultSend.vue?vue&type=script&lang=js&"
export * from "./PwSearchResultSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7e24e9",
  null
  
)

export default component.exports